import {
	Component,
	ElementRef,
	EventEmitter, HostListener,
	Input, OnInit,
	Output, Renderer2,
	ViewChild
} from '@angular/core';

@Component({
	selector: 'cv-multiselect',
	templateUrl: './multiselect.component.html',
	styleUrls: ['./multiselect.component.scss']
})
export class MultiselectComponent implements OnInit {
	/**
	 * If true determines if dropdown should be required and applies style to it when empty.
	 */
	@Input() required: boolean;
	/**
	 * The label of the dropdown input.
	 */
	@Input() label: string;

	/**
	 * @public If `true`, the user cannot interact with the input.
	 */
	@Input() disabled: boolean;

	/**
	 * @public property set the width of the dropdown by default is '100%'
	 */
	@Input() width: string;

	/**
	 * @public property that receives if the element value is valid
	 */
	@Input() valid = true;
	@Input() options: Array<any>;
	@Input() values: Array<any>;
	@Input() optionValue: string;
	@Input() optionText: string;
	@Input() placeholder: string;
	@Output() valuesChange: EventEmitter<any> = new EventEmitter<any>();
	@Output() openMenu: EventEmitter<any> = new EventEmitter<any>();
	@Output() closeMenu: EventEmitter<any> = new EventEmitter<any>();
	@ViewChild('dropdownButton', {static: true}) dropdownButton: ElementRef<any>;
	@ViewChild('dropdownMenu', {static: true}) dropdownMenu: ElementRef<any>;
	isOpen: boolean;
	currentValues: Array<any>;
	randomID: number;

	constructor(private elementRef: ElementRef, private renderer: Renderer2) {
		this.options = [];
		this.values = [];
		this.width = '100%';
		this.placeholder = 'Select an option';
		this.isOpen = false;
		this.randomID = Math.random() * 10000;
	}

	ngOnInit(): void {
		this.currentValues = [...this.values];
	}

	/**
	 * Closes the dropdown menu is user clicks outside.
	 * @param $event: any
	 */
	@HostListener('document:click', ['$event'])
	onClickOutside($event: any): void {
		if (!this.dropdownButton.nativeElement.contains($event.target)
		&& !this.dropdownMenu.nativeElement.contains($event.target)) {
			this.toggleMenu(true);
		}
	}

	/**
	 * Emits the valuesChange event.
	 */
	onValuesChange(): void {
		this.valuesChange.emit(this.currentValues);
	}

	/**
	 * Toggles(Display or hide) the dropdown menu. If it's display action it calculates the position based
	 * on the button position.
	 * @param forceClose: if true then closes the dropdown menu.
	 */
	toggleMenu(forceClose: boolean = false): void {
		this.isOpen = forceClose ? false : !this.isOpen;
		if (this.isOpen) {
			const top = this.dropdownButton.nativeElement.offsetTop + this.dropdownButton.nativeElement.offsetHeight;
			const left = this.dropdownButton.nativeElement.offsetLeft;
			this.renderer.setStyle(this.dropdownMenu.nativeElement, 'top', `${top}px`);
			this.renderer.setStyle(this.dropdownMenu.nativeElement, 'left', `${left}px`);
			this.renderer.setStyle(this.dropdownMenu.nativeElement, 'display', 'block');
			this.openMenu.emit();
		} else {
			this.renderer.setStyle(this.dropdownMenu.nativeElement, 'display', 'none');
			this.closeMenu.emit();
		}
	}

	/**
	 * Returns if option is currently selected.
	 * @param option: any
	 */
	isOptionSelected(option: any): boolean {
		const match = this.currentValues.find(value => value[this.optionValue] === option[this.optionValue]);
		return match;
	}

	/**
	 * Add or remove the option into the current selected values array.
	 * @param $event: any
	 * @param option: any
	 */
	toggleOption($event: any, option: any): void {
		if ($event.target.checked) {
			this.currentValues.push(option);
		} else {
			const index = this.currentValues.findIndex(value => value[this.optionValue] === option[this.optionValue]);
			if (index > -1) {
				this.currentValues.splice(index, 1);
			}
		}
		this.onValuesChange();
	}

	/**
	 * Sets values to empty array.
	 */
	clearValues(): void {
		this.currentValues.splice(0);
		this.onValuesChange();
	}

	/**
	 * Returns true if component value is valid
	 */
	isValid(): boolean {
		if (this.required) {
			return this.currentValues !== undefined
				&& this.currentValues !== null
				&& this.currentValues.length > 0;
		}
		return true;
	}
}
